import { RoleGrantCoreBase } from "./role-grant.core.base"


export class RoleGrantCore extends RoleGrantCoreBase {

}